package com.hyperether.goodjob.util

import com.hyperether.goodjob.models.JobStatus
import com.hyperether.planner.model.EventStatus

object EventStatusMapper {
    fun eventStatus(status: JobStatus): EventStatus {
        return when (status) {
            JobStatus.draft -> EventStatus.DRAFT
            JobStatus.open -> EventStatus.OPEN
            JobStatus.in_progress -> EventStatus.IN_PROGRESS
            JobStatus.on_hold -> EventStatus.ON_HOLD
            JobStatus.pendingApproval -> EventStatus.PENDING_APPROVAL
            JobStatus.cancelled -> EventStatus.CANCELLED
            JobStatus.completed -> EventStatus.COMPLETED
        }
    }
}